module.exports = __webpack_public_path__ + "img/stackslash-process-5.8b7f45b2.jpg";